import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { VoucherActivation } from './VoucherActivation';
import { VoucherSuccess } from './VoucherSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep4() {
  // Context
  const { step4SubStep, setShowActivationFooter, setShowActivationHeader } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: handle page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationVoucherPageTitle = tA11yTranslate('ek_global_meta_title_voucher').content;
  const isTranslationReady = keyValueValidation(
    activationVoucherPageTitle,
    'ek_global_meta_title_voucher'
  );

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step4SubStep === 1) {
      return `${globalPageTitle} - ${globalSuccessPageTitle}`;
    } else {
      return `${globalPageTitle} - ${activationVoucherPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step4SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // Hide footer for below screens
    // 0.1.5.3 - registration step 4 - vouchercode success
    if (step4SubStep === 1) {
      setShowActivationFooter(false);
    } else {
      setShowActivationFooter(true);
      setShowActivationHeader(true);
    }
  }, [step4SubStep]);

  const renderStep4SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <VoucherActivation />;
      case 1:
        return <VoucherSuccess />;
      default:
        return <VoucherActivation />;
    }
  };
  
  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step4SubStep}`} />
      {renderStep4SubSteps(step4SubStep)}
    </>
  );
}

export default ActivationStep4;
